'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _AmountItem = require('./AmountItem');

var _AmountItem2 = _interopRequireDefault(_AmountItem);

var _LimitStatus = require('./LimitStatus');

var _Button = require('../../components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _Translate = require('../../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResponsibleGamingSingleSignUp = function (_Component) {
  _inherits(ResponsibleGamingSingleSignUp, _Component);

  function ResponsibleGamingSingleSignUp(props) {
    _classCallCheck(this, ResponsibleGamingSingleSignUp);

    var _this = _possibleConstructorReturn(this, (ResponsibleGamingSingleSignUp.__proto__ || Object.getPrototypeOf(ResponsibleGamingSingleSignUp)).call(this, props));

    _this.checkErrors = function (values) {
      var _this$state = _this.state,
          touchedDeposit_1 = _this$state.touchedDeposit_1,
          touchedDeposit_7 = _this$state.touchedDeposit_7,
          touchedDeposit_30 = _this$state.touchedDeposit_30;


      var config = _this.props.data[0].config;

      var day = parseInt(values['Deposit_1']);
      var week = parseInt(values['Deposit_7']);
      var month = parseInt(values['Deposit_30']);

      var emptyFieldError = _react2.default.createElement(_Translate2.default, { id: 'label.empty-field', defaultMessage: 'Empty field' });

      var errors = {};

      if (!day && config.find(function (c) {
        return c.value === 1;
      }).required && touchedDeposit_1) errors['Deposit_1'] = emptyFieldError;
      if (!week && config.find(function (c) {
        return c.value === 7;
      }).required && touchedDeposit_7) errors['Deposit_7'] = emptyFieldError;
      if (!month && config.find(function (c) {
        return c.value === 30;
      }).required && touchedDeposit_30) errors['Deposit_30'] = emptyFieldError;

      if (week < day) errors['Deposit_7'] = _react2.default.createElement(_Translate2.default, {
        id: 'setlimits.error.week',
        defaultMessage: 'Weekly limit cannot be lower than the daily limit'
      });
      if (month < day || month < week) errors['Deposit_30'] = _react2.default.createElement(_Translate2.default, {
        id: 'setlimits.error.month',
        defaultMessage: 'Monthly limit cannot be lower than the weekly limit'
      });

      if (day < 0) errors['Deposit_1'] = _react2.default.createElement(_Translate2.default, {
        id: 'setlimits.error.negative.day',
        defaultMessage: 'Daily limit cannot be negative'
      });
      if (week < 0) errors['Deposit_7'] = _react2.default.createElement(_Translate2.default, {
        id: 'setlimits.error.negative.week',
        defaultMessage: 'Weekly limit cannot be negative'
      });
      if (month < 0) errors['Deposit_30'] = _react2.default.createElement(_Translate2.default, {
        id: 'setlimits.error.negative.month',
        defaultMessage: 'Monthly limit cannot be negative'
      });

      return errors;
    };

    _this.state = {
      values: props.data && props.data[0].values,
      touchedDeposit_1: false,
      touchedDeposit_7: false,
      touchedDeposit_30: false
    };
    return _this;
  }

  _createClass(ResponsibleGamingSingleSignUp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var values = this.state.values;


      if (Object.keys(values).length > 0) {
        var daily = values['Deposit_1'];
        var weekly = values['Deposit_7'];
        var monthly = values['Deposit_30'];

        var newValues = {};

        if (daily) newValues = this.getValues('Deposit_1', daily);else if (weekly) newValues = this.getValues('Deposit_7', weekly);else if (monthly) newValues = this.getValues('Deposit_30', monthly);

        newValues = _extends({}, newValues, values);

        this.setState({ values: newValues });
      }
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(e) {
      e.preventDefault();
      var values = this.state.values;


      var data = {
        values: {}
      };

      this.props.data[0].config.forEach(function (c) {
        data.values[c.value] = parseInt(values['Deposit_' + c.value] || 0);
      });

      this.props.onSubmitLimits && this.props.onSubmitLimits(data);

      return data;
    }
  }, {
    key: 'getValues',
    value: function getValues(timespan, value) {
      this.setState(_defineProperty({}, 'touched' + timespan, true));
      var _state = this.state,
          touchedDeposit_1 = _state.touchedDeposit_1,
          touchedDeposit_7 = _state.touchedDeposit_7,
          touchedDeposit_30 = _state.touchedDeposit_30;


      var dayValue = timespan === 'Deposit_1' ? value : timespan === 'Deposit_7' ? Math.round(value / 7) : Math.round(value / 30);

      var newValues = {};

      newValues[timespan] = value;

      if (timespan !== 'Deposit_1' && !touchedDeposit_1) newValues['Deposit_1'] = dayValue;
      if (timespan !== 'Deposit_7' && !touchedDeposit_7) newValues['Deposit_7'] = dayValue * 7;
      if (timespan !== 'Deposit_30' && !touchedDeposit_30) newValues['Deposit_30'] = dayValue * 30;

      return newValues;
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      var currentValues = this.state.values;


      var values = _extends({}, currentValues, this.getValues(e.target.name, e.target.value));

      this.setState({
        values: values
      });

      this.props.onChangeLimits && this.props.onChangeLimits({
        values: values
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          header = _props.header,
          currency = _props.currency,
          hideSubmitBtn = _props.hideSubmitBtn,
          data = _props.data;
      var values = this.state.values;


      var timespanTranslations = {
        1: _react2.default.createElement(_Translate2.default, { id: 'label.each_day', defaultMessage: 'Each day' }),
        7: _react2.default.createElement(_Translate2.default, { id: 'label.each_week', defaultMessage: 'Each week' }),
        30: _react2.default.createElement(_Translate2.default, { id: 'label.each_month', defaultMessage: 'Each month' })
      };

      var responsibleGamingContent = (0, _get2.default)(data[0], 'content', '');

      return _react2.default.createElement(
        'div',
        { className: 'responsiblegaming-signup' },
        header && header.content && _react2.default.createElement('header', {
          dangerouslySetInnerHTML: { __html: (0, _marked2.default)(header.content) }
        }),
        _react2.default.createElement('div', {
          className: 'responsible-gaming-content',
          dangerouslySetInnerHTML: { __html: responsibleGamingContent }
        }),
        _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return _this2.onSubmit(e);
            } },
          data[0].config.map(function (config) {
            return _react2.default.createElement(
              _react.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { className: 'timespan-label' },
                timespanTranslations[config.value]
              ),
              _react2.default.createElement(_AmountItem2.default, {
                onChange: function onChange(e) {
                  return _this2.onChange(e);
                },
                timespan: 'Deposit_' + config.value,
                error: _this2.checkErrors(values)['Deposit_' + config.value],
                currency: currency,
                defaultValue: values['Deposit_' + config.value],
                initialStepValue: (0, _get2.default)(config, ['initialStepValue', currency || 'EUR'], 100 * config.value)
              })
            );
          }),
          values && Object.keys(values).map(function (key, index) {
            var period = timespanTranslations[key.split('_')[1]];

            return parseInt(values[key]) > 0 && _react2.default.createElement(_LimitStatus.ActiveLimit, {
              amount: parseInt(values[key]),
              key: index,
              period: period,
              currency: currency
            });
          }),
          !hideSubmitBtn && _react2.default.createElement(
            _Button2.default,
            {
              className: 'button primary wide',
              disabled: Object.keys(this.checkErrors(values)).length !== 0 || Object.keys(values).length === 0 || Object.values(values).some(function (val) {
                return Number(val) === 0;
              }) },
            _react2.default.createElement(_Translate2.default, { id: 'setlimits.save', defaultMessage: 'Set limits' })
          )
        ),
        _react2.default.createElement(
          'p',
          { className: 'notice' },
          _react2.default.createElement(_Translate2.default, {
            id: 'setlimits.crossbrand-notice',
            tagName: 'small',
            defaultMessage: 'Please note that these limits will apply on all websites related to the licence XX000000'
          })
        )
      );
    }
  }]);

  return ResponsibleGamingSingleSignUp;
}(_react.Component);

exports.default = ResponsibleGamingSingleSignUp;